import { Injectable } from "@angular/core";
import { IUrlJsonObjectVM } from "../models";
import { CryptoManagerService } from "./crypto-manager.service";
import { UrlDataBuilder } from "./url-data-builder";

@Injectable({
    providedIn: 'root'
})
export class UrlDataService {
    constructor(private cryptoManagerService: CryptoManagerService) { }

    getDataBuilder = (): UrlDataBuilder => {
        return new UrlDataBuilder(this.cryptoManagerService);
    }

    getPatientId = (urlData: string): number => {
        return this.getObjectFromBase64Url(urlData).pId || 0;
    }

    getEncounterId = (urlData: string): number => {
        return this.getObjectFromBase64Url(urlData).enId || 0;
    }

    private getObjectFromBase64Url = (urlData: string): IUrlJsonObjectVM => {
        return (this.cryptoManagerService.getObjectFromBase64Url(urlData) || {});
    }
}